import React from 'react';

import { useSelector } from 'react-redux';

import Style from './Submit.module.css';

import { Button } from '../../../atoms';

function Submit() {
  const { job_details } = useSelector((state) => state);

  return (
    <div className='padding32T'>
      <div className={Style.GreenBox}>
        <div className='x-y-center-Pos w-90'>
          <img src='/images/Apply/tick-circle.svg' />
          <div className={Style.sucessText}>Applied Successfully</div>
          <div className={Style.sucessSubText} data-testid='success-message'>
            You have successfully applied to {job_details?.data?.data?.job_role_name ? job_details?.data?.data?.job_role_name : job_details?.data?.data?.posting_title} post with
            Awign Expert.
          </div>
        </div>
      </div>
      <div className='row margin-0'>
        <div className='col-6 flexStyleEnd'>
          <a href='/jobs/applied-jobs'>
            <Button className='general-outline-style mt-4 paddingTop padding32L padding32R'>My Dashboard</Button>
          </a>
        </div>
        <div className='col-6 flexStyleStart'>
          <a href='/jobs/explore'>
            <Button className='general-style padding32L padding32R mt-4'>Browse Jobs</Button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Submit;
